// components/dnd/list/task-list/task-list.component.jsx
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Draggable } from "react-beautiful-dnd";

import {
  db,
  updateTaskAsDone,
  fieldValue,
} from "../../../../firebase/firebase.utils";
import { useNavigate } from "react-router-dom";

import { autoUpdateTasksToUser, setTaskClassDone } from "../../task.util";
import "./task-list.styles.scss";

import LoadModule from "../../../modules/load-module.component.jsx/load-module.component";
import Subtasks from "../../subtasks/subtasks.component";

import { BsGripVertical } from "react-icons/bs";
import { FiSquare, FiCheckSquare } from "react-icons/fi";

const TaskList = ({ task, index, status, stationTasksFL }) => {
  const activeModules = useSelector((state) => state.space.activeModulesData);
  const users = useSelector((state) => state.user.users);
  const filter = useSelector((state) => state.filter);

  const activeSpaceId = useSelector((state) => state.history.spaceId);
  const activeStationId = useSelector((state) => state.history.stationId);

  const [taskref, setTaskRef] = useState(false);
  const [taskdone, setTaskDone] = useState(false);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [activeEvent, setActiveEvent] = useState({});

  const navigate = useNavigate();
  const [taskClass, setTaskClass] = useState("");

  const taskrefinfo = {
    fromSpaceId: activeSpaceId,
    fromStationId: activeStationId,
    id: task,
    done: !taskdone,
  };

  const handleCheck = () => {
    document.getElementById("done_tone").play();
    if (taskdone) {
      updateTaskAsDone(activeSpaceId, activeStationId, task, false);
    } else {
      updateTaskAsDone(activeSpaceId, activeStationId, task, true);
    }
    if (taskref.assign) {
      const assignedUserRef = db.collection("users").doc(taskref.assign);
      assignedUserRef.get().then((userRefData) => {
        let assignedTasks = userRefData.data().assignedTasks;
        const findIndex = assignedTasks.findIndex((item) => item.id === task);
        assignedUserRef.update({
          assignedTasks: fieldValue.arrayRemove(assignedTasks[findIndex]),
        });
        assignedUserRef.update({
          assignedTasks: fieldValue.arrayUnion(taskrefinfo),
        });
      });
    }
  };

  useEffect(() => {
    db.collection("space")
      .doc(activeSpaceId)
      .collection("stations")
      .doc(activeStationId)
      .collection("tasks")
      .doc(task)
      .onSnapshot((doc) => {
        if (doc.exists) {
          let currenttask = doc.data();
          setTaskRef(currenttask);
          setTaskDone(currenttask.done);
        }
      });
  }, []);

  const handleEventClick = (taskref, event) => {
    if (!taskref?.id) return;
    const rect = event.currentTarget
      .closest(".taskList")
      .getBoundingClientRect();

    navigate(`task/${taskref.id}`, {
      state: {
        taskOrigin: {
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
        },
      },
    });
  };

  useEffect(() => {
    autoUpdateTasksToUser(users, task);
    setTaskClass(setTaskClassDone(task));
  }, [task]);

  return (
    <Draggable draggableId={task} index={index}>
      {(provided) => {
        const style = {
          ...provided.draggableProps.style,
          opacity: status.open ? "1" : "0",
          height: status.open ? "auto" : "10px",
        };
        return (
          <div
            {...provided.draggableProps}
            ref={provided.innerRef}
            className="taskList__logic"
            style={style}
          >
            <div className="tl__drag" {...provided.dragHandleProps}>
              <BsGripVertical size="1.3rem" />
            </div>
            {/* {filterLogic && ( */}
            {stationTasksFL.findIndex((item) => item.id === task) !== -1 && (
              <div className={`taskList ${taskClass}`}>
                <div className="tl__clickable" {...provided.dragHandleProps} />
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className={
                      taskref.done ? "task__listcard-done" : "task__listcard"
                    }
                  >
                    {/* <CheckBox task={task} /> */}
                    <div className="tl__taskheader">
                      <i onClick={handleCheck}>
                        {taskref.done ? <FiCheckSquare /> : <FiSquare />}
                      </i>
                      <audio
                        id="done_tone"
                        src="/media/mixkit-cool-interface-click-tone-2568.wav"
                      ></audio>
                      <p onClick={(event) => handleEventClick(taskref, event)}>
                        {taskref.title}
                      </p>
                    </div>
                    <div className="tl__modules">
                      {activeModules?.map((module) => {
                        return (
                          <LoadModule
                            style="vertical"
                            module={module}
                            key={module.name}
                            task={taskref}
                          />
                        );
                      })}
                    </div>
                  </div>

                  <Subtasks task={taskref} open={false} length />
                </div>
              </div>
            )}

            {/* )} */}
          </div>
        );
      }}
    </Draggable>
  );
};

export default TaskList;
